"use client";

import { Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ClientReviews() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const testimonials = [{
    quote: "The service was impeccable. My chauffeur arrived early, the vehicle was spotless, and the ride to LAX was smooth and stress-free. Highly recommended for business travel.",
    name: "Robert J.",
    role: "Corporate Executive",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_robert.webp",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_robert.webp-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_robert.webp-wvc-sizes",
    featured: true,
    rating: 5
  }, {
    quote: "Professional, discreet, and punctual. Phoenix Enterprise TCP made our VIP guest feel completely taken care of during their stay in Los Angeles.",
    name: "Sarah L.",
    role: "Event Coordinator",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_sarah.webp",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_sarah.webp-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_sarah.webp-wvc-sizes",
    featured: false,
    rating: 5
  }, {
    quote: "I rely on them for all my airport transfers. The black car quality is unmatched, and the drivers are always professional and knowledgeable about the city.",
    name: "David M.",
    role: "Frequent Traveler",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_david.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_david.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_david.png-wvc-sizes",
    featured: false,
    rating: 5
  }, {
    quote: "Exceptional attention to detail. From the initial booking to the final drop-off, everything was handled with absolute precision and luxury.",
    name: "Elena K.",
    role: "Luxury Concierge",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_elena.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_elena.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_elena.png-wvc-sizes",
    featured: false,
    rating: 5
  }, {
    quote: "The best chauffeur service in Southern California. Their fleet is top-tier, and the privacy they provide is exactly what I need for my business meetings.",
    name: "Marcus T.",
    role: "Business Owner",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_marcus.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_marcus.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_marcus.png-wvc-sizes",
    featured: true,
    rating: 5
  }, {
    quote: "Reliable and upscale. They made our special event transportation seamless. I wouldn't trust anyone else with my travel needs in LA.",
    name: "Jessica W.",
    role: "Private Client",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_jessica.png",
    avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_jessica.png-wvc-srcset",
    avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/client_jessica.png-wvc-sizes",
    featured: false,
    rating: 5
  }];
  return;
}